<div [matMenuTriggerFor]="menu" class="px-3 sen-cursor-pointer">
    {{translate.getLng('SET_PAGE_MARGIN')}} <mat-icon>pages</mat-icon>
</div>
<mat-menu class="position-relative sen-margin-box" #menu="matMenu">
    <div class="mb-3 overflow-hidden p-3" (click)="$event.stopPropagation();">
        <table>
            <tr>
                <td class="font-weight-bold">{{translate.getLng('PAGE_BORDERS')}}</td>
                <td class="p-2"></td>
                <td></td>
            </tr>
            <tr>
                <td>{{translate.getLng('BORDER_LEFT')}}</td>
                <td class="p-2">:</td>
                <td>
                    <mat-form-field class="sen-number-input text-right font-weight-bold sen-fs16" fxFlex="1 1 25%">
                        <input type="number" min="20" value="20" max="40" matInput>
                    </mat-form-field> {{translate.getLng('MM')}}
                </td>
            </tr>
            <tr>
                <td class="text-nowrap">{{translate.getLng('BORDER_RIGHT')}}
                </td>
                <td class="p-2">:</td>
                <td>
                    <mat-form-field class="sen-number-input text-right font-weight-bold sen-fs16" fxFlex="1 1 25%">
                        <input disabled type="number" min="10" value="10" max="30" matInput>
                    </mat-form-field> {{translate.getLng('MM')}}
                </td>
            </tr>
        </table>
    </div>
    <button type="button" class="px-4 sen-ok-button" mat-raised-button
        color="primary">{{translate.getLng('OK')}}</button>
</mat-menu>